var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCellSignalHigh = function SvgIconCellSignalHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.662 2.44a1.75 1.75 0 0 0-1.906.39L1.33 18.255a1.75 1.75 0 0 0 1.229 2.994H18a1.75 1.75 0 0 0 1.75-1.75V4.058a1.75 1.75 0 0 0-1.088-1.617m-.912 16.81V4.664L16 6.414V19.25zm-3.75 0H3.164L14 8.414z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCellSignalHigh;